export default "__VITE_ASSET__DGRBk1dt__"